var map = {
	"./flight.svg": 533,
	"./food.svg": 463,
	"./hotels.svg": 362,
	"./sight-seeing.svg": 424,
	"./tickets.svg": 426,
	"./tour-manager.svg": 623,
	"./transfer.svg": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;